var _effectorFileName = "/builds/gmini/front-sm-api-sdk/src/SourceProps.ts";
import * as t from 'io-ts';
import { Id } from './Id';
import { Version } from './Version';
export var SourceRelationType = t.union([t.literal('Direct'), t.literal('Indirect')], 'SourceRelationType');
export var ReferenceSource = t.type({
  sourceClassifierId: Id,
  sourceClassifierVersion: Version,
  sourceRefId: Id,
  relationType: SourceRelationType
}, 'ReferenceSource');